/* eslint-disable @next/next/no-img-element */
import SplitLines from 'assets/university/split-lines.png'
import GlobeIcon from 'assets/university/globe.svg'
import EducationHat from 'assets/university/graduation-hat.svg'
import AppOfTheDay from 'assets/university/app-of-the-day.webp'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import { KnowunityNumbers } from 'lib/constants/KnowunityNumbers'
import { Body2 } from 'stories/elements/Typography/Text'

const Container = styled.div`
    display: flex;
    justify-content: center;
    gap: 24px;
    width: 100%;
    padding: 50px 20px;
    background-color: ${theme.colors.darkBlackTransparent};
    @media (max-width: 750px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`

const Card = styled.div`
    border-radius: ${theme.borderRadius.normal};
    border: 1px solid var(--Core-Grayscale-Dividers, #ffffff26);
    background-color: ${theme.colors.headlineDark};
    width: 300px;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 20px;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(${SplitLines.src});
        background-size: cover;
        background-position: center;
        opacity: 0.7;
        z-index: 0;
    }
`

const StatContent = styled.div`
    position: relative;
    height: 100%;
    padding: 25px 15px;
    z-index: 1;
    p {
        font-size: 28px;
        line-height: 38px;
        color: ${theme.colors.white};
    }
`

const IconWrapper = styled.div`
    position: absolute;
    right: 0;
    bottom: -5px;
    opacity: 0.3;
    z-index: 1;

    img {
        width: 80px;
        height: 80px;
    }
`

const AppAwardCard = styled(Card)`
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 0;

    &::before {
        display: none;
    }
`

const StatisticsRow = () => {
    return (
        <Container>
            <Card>
                <StatContent>
                    <Body2>{KnowunityNumbers.downloadMillionCount}+ Millionen Lernende</Body2>
                </StatContent>
                <IconWrapper>
                    <EducationHat />
                </IconWrapper>
            </Card>

            <Card>
                <StatContent>
                    <Body2>{KnowunityNumbers.activeCountryCount} Länder</Body2>
                </StatContent>
                <IconWrapper>
                    <GlobeIcon />
                </IconWrapper>
            </Card>

            <AppAwardCard>
                <img src={AppOfTheDay.src} alt="App of the day award" width={223} height={168} />
            </AppAwardCard>
        </Container>
    )
}

export default StatisticsRow
